import ProgressHeader from '../Components/Styled/ProgressHeader';
import { Col, Row } from 'antd';
import AppleGoogleButtons from '../Components/Styled/AppleGoogleButtons';
import { Fragment, useEffect } from 'react';
import DigsPlanWelcome from '../Components/DigsPlanWelcome';
import FAQSection from '../Components/FAQSection';
import {
  CAMPAIGN_PRICING,
  MEETING_SUCCESS_FAQ,
  PER_MONTH,
  PER_SERVICE,
  PER_SERVICE_FAQ,
} from '../constants';
import { useCustomer } from '../common/customerContext';
import DigsNoCCPlanWelcome from '../Components/DigsNoCCPlanWelcome';

const SuccessPlan = () => {
  const customer = useCustomer();
  useEffect(() => {
    if (!customer.campaignCode) {
      window.sessionStorage.clear();
    }
  }, []);
  return (
    <Fragment>
      <Row type="flex" justify="center">
        <ProgressHeader
          hasNav={true}
          showBackIcon={customer.campaignCode && !customer.cartId}
        />
        <Col xs={0} md={5} lg={6}></Col>
        <Col
          xs={24}
          md={14}
          lg={12}
          style={{ marginTop: '16px' }}
          className="padMobile"
        >
          {CAMPAIGN_PRICING[customer.campaignCode] === PER_SERVICE ? (
            <DigsNoCCPlanWelcome />
          ) : (
            <DigsPlanWelcome />
          )}
        </Col>
        <Col xs={0} md={5} lg={6}></Col>
        <Col xs={0} md={5} lg={6}></Col>
      </Row>
      {CAMPAIGN_PRICING[customer.campaignCode] === PER_SERVICE && (
        <FAQSection data={MEETING_SUCCESS_FAQ} />
      )}
    </Fragment>
  );
};

export default SuccessPlan;
